import { Provider } from 'modules/transmission/types'
import { VIMEO_REGEX, EMBED_PARAMS, VIMEO_EMBED_URL, VIMEO_EVENT_EMBED_URL } from '../../constants'

export default class VimeoHelper {
  static getIdFromUrl = (url: string) => {
    if (VIMEO_REGEX.test(url)) {
      const routes = url.replace(VIMEO_REGEX, '').split('/')

      return routes[0]
    }

    console.error(`Failed to extract id from Vimeo url "${url}"`)

    return ''
  }

  static getEmbedURL = (url: string) => {
    const isEvent = url.includes('vimeo.com/event/')
    const id = VimeoHelper.getIdFromUrl(url)
    const params = EMBED_PARAMS[Provider.VIMEO]?.join('&') || ''

    return (
      isEvent
        ? `${VIMEO_EVENT_EMBED_URL}?${params}`
        : `${VIMEO_EMBED_URL}?${params}`
    ).replace(':id', id)
  }
}
